import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const CompanyId = z.coerce.number().int().positive();
const CompanyParams = z.object({ companyId: CompanyId });
const MessageResponse = z.object({ message: z.string() });
const CompanySettings = z.object({
    isKickOffEnabled: z.boolean().optional(),
    isCompanyProjectUploadsEnabled: z.boolean().optional(),
    isRetroSurveyEnabled: z.boolean().optional(),
    isCohortWelcomeEmailEnabled: z.boolean().optional(),
    isOfficeHoursRemindersEnabled: z.boolean().optional(),
    isLearningPlanNotificationsEnabled: z.boolean().optional(),
    isAssessmentTestEnabled: z.boolean().optional(),
    logoUrl: z.string().nullable().optional(),
});
export const addCompanyRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies',
    name: 'add-company',
    request: {
        body: z.object({
            name: z.string().min(1),
            slug: z.string().min(1),
            ...CompanySettings.shape,
        }),
    },
    responses: { 200: MessageResponse, 400: HttpErrorResponse },
};
export const updateCompanyRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}',
    name: 'update-company',
    request: { params: CompanyParams, body: CompanySettings },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const addLearnersRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/learners',
    name: 'add-learners',
    request: {
        params: CompanyParams,
        body: z.object({
            learners: z
                .array(z.object({ name: z.string().min(1), email: z.string().email() }))
                .min(1),
        }),
    },
    responses: {
        200: MessageResponse.extend({
            added: z.array(z.string()),
            skipped: z.array(z.string()),
        }),
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const editLearningPlansRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/learning-plans',
    name: 'edit-learning-plans',
    request: {
        params: CompanyParams,
        body: z.object({
            learners: z
                .array(z.object({
                id: z.number().int().positive(),
                learningPlan: z.unknown().nullable(),
            }))
                .min(1),
        }),
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const assignMentorToCompanyRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/assign-mentor',
    name: 'assign-mentor-to-company',
    request: {
        params: CompanyParams,
        body: z.object({ mentorProfileId: z.number().int().positive() }),
    },
    responses: {
        200: MessageResponse.extend({
            mentorProfileId: z.number(),
            companyId: z.number(),
        }),
        400: HttpErrorResponse,
        404: HttpErrorResponse,
        409: HttpErrorResponse,
    },
};
export const createMentorRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/mentors',
    name: 'create-mentor',
    request: {
        body: z.object({ name: z.string().min(1), email: z.string().email() }),
    },
    responses: {
        201: MessageResponse.extend({
            mentorProfile: z.object({
                id: z.number(),
                user_id: z.number(),
                status: z.string(),
            }),
            user: z.object({
                id: z.number(),
                name: z.string(),
                email: z.string().email(),
                roles: z.array(z.string()),
            }),
        }),
        400: HttpErrorResponse,
        409: HttpErrorResponse,
    },
};
